export default function(ipackage) {
    
    let volumetric = (ipackage.width * ipackage.height * ipackage.length) / 5000

    volumetric = volumetric > ipackage.weight ? volumetric : ipackage.weight

    return parseFloat(volumetric).toFixed(2)
}